import React from 'react';

import { FormControlLabel, Radio, RadioGroup, styled } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useContainer } from 'unstated-next';

import ClassContainer from './ClassContainer';

const StyledRadioGroup = styled(RadioGroup)`
    margin-left: 2rem;
`;

const TemplateOptions: React.FC = () => {
    const { control, watch, publishedTemplates } = useContainer(ClassContainer);

    const courseTemplate = watch('courseTemplate');

    if (courseTemplate) {
        return (
            <Controller
                name="courseTemplateId"
                control={control}
                render={(props) => (
                    <StyledRadioGroup
                        {...props.field}
                    >
                        {publishedTemplates.map((publishedTemplate) => (
                            <FormControlLabel
                                label={publishedTemplate.class_name}
                                value={publishedTemplate.sid}
                                key={publishedTemplate.sid}
                                control={
                                    <Radio />
                                }
                            />
                        ))}
                    </StyledRadioGroup>
                )}
            />
        );
    }

    return null;
};

export default TemplateOptions;
